import { type TranslationTree } from '@/i18n/types';

export const messages = {
  loadError: 'Não foi possível carregar a oferta',
} satisfies TranslationTree;
